export const InboxBikeDetail = () => {
  return <></>;
};
